export default __webpack_public_path__ + "static/media/Main.a6944b32.png";